module.exports = __webpack_public_path__ + "static/img/5-bg.587bd3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/5-bg.png
// module id = kmIb
// module chunks = 0